const flightData = (state = {}, action) => {
    switch (action.type) {
        case 'SAVE_FLIGHT_DATA':
            return action.flightData
        default:
            return state
    }
}

export default flightData